import { CONCLUSION_TIME_ERRORS } from "@/utils/constants/attendanceClock";
import { showNotifyError } from "./notifyHelper";

export const validateConclusionTime = (initialTime, conlusionTime) => {
  
  if (conlusionTime && initialTime) {

    const isValid = conlusionTime >= initialTime;

    const isSameTime = conlusionTime === initialTime;
    
    if (!isValid) {
      showNotifyError(CONCLUSION_TIME_ERRORS.START_AFTER_END);
    }

    if (isSameTime) {
      showNotifyError(CONCLUSION_TIME_ERRORS.START_EQUALS_END);
    }
    return isValid && !isSameTime;
  }
};